export default __webpack_public_path__ + "static/media/093-diagonal-arrow-9.cd2ace92.png";